module.exports = __webpack_public_path__ + "media/border-bee.46394c31.mp4";